module.exports = __webpack_public_path__ + "img/ic-quality-check-gray.e02f692a.svg";